import { logDebug } from 'middleware/logger';
import AppEnvironment from 'helpers/AppEnvironment';
import { recordToSplunk } from 'apis/recordToSplunk';

export const MAX_EVENTS_PER_BATCH = 10;
export const DEBOUNCE_MS = 1000;

let eventQueue: unknown[] = [];
let debounceTimer: ReturnType<typeof setTimeout> | null = null;

export const flush = () => {
  if (!eventQueue.length) {
    return;
  }
  const batch = eventQueue;
  eventQueue = [];
  if (debounceTimer) {
    clearTimeout(debounceTimer);
    debounceTimer = null;
  }
  recordToSplunk(`type=zfc-event&data=${encodeURIComponent(JSON.stringify(batch))}`);
};

export const scheduleFlush = () => {
  if (debounceTimer) {
    clearTimeout(debounceTimer);
  }
  if (eventQueue.length >= MAX_EVENTS_PER_BATCH) {
    flush();
    return;
  }
  debounceTimer = setTimeout(flush, DEBOUNCE_MS);
};

// flush remaining events on page unload, same as Titanite's beforeunload handler
if (AppEnvironment.isClient) {
  window.addEventListener('beforeunload', flush);
}

const zfcEventLog = (...args: unknown[]) => {
  logDebug('zfc-event', ...args);
  if (AppEnvironment.isClient) {
    eventQueue.push(args.length === 1 ? args[0] : args);
    scheduleFlush();
  }
};

// exposed for testing
export const _getQueue = () => eventQueue;
export const _resetQueue = () => {
  eventQueue = [];
  if (debounceTimer) {
    clearTimeout(debounceTimer);
    debounceTimer = null;
  }
};

export default zfcEventLog;
